export default __webpack_public_path__ + "static/media/pantone.d93d031c.png";